//TODO: Move to Chops?

const getLocalStorageValue = (storageKey: string): string | null | undefined => {
  try {
    return localStorage.getItem(storageKey);
  } catch {
    //Do Nothing
  }
};

export default getLocalStorageValue;
